<template>
  <div class="rates">
    <h2>Таблица за ставки</h2>
    <p class="rates-info">
      Ставки на ден (EUR). Промяната се запазва веднага и се зарежда в Форма Заплата
      при следващото отваряне (вече запазените форми не се променят).
    </p>
    <input
      class="rates-search"
      type="text"
      placeholder="Търсене по име"
      v-model="search"
    />

    <div class="table-wrapper" v-if="workers.length">
      <table class="rates-table">
        <thead>
          <tr>
            <th>№</th>
            <th class="name">Служител</th>
            <th v-for="c in columns" :key="c.key">{{ c.name }}</th>
            <th>Последна промяна</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(w, i) in filtered" :key="w._id">
            <td>{{ i + 1 }}</td>
            <td class="name">{{ w.name }}</td>
            <td v-for="c in columns" :key="c.key" :class="{ saving: w.saving }">
              <input
                type="number"
                min="0"
                step="0.01"
                v-model="w.rates[c.key]"
                @change="save(w)"
              />
            </td>
            <td class="updated">{{ w.updatedAt ? formatDateTime(w.updatedAt) : "-" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p v-else-if="loaded" class="rates-empty">Няма активни работници</p>
  </div>
</template>

<script>
import log from "./mixins/log.js";

const RATE_COLUMNS = [
  { key: "workday", name: "Делнична (пн-пт)" },
  { key: "weekendHoliday", name: "Сб / Нд / Нац. празник" },
  { key: "paidLeave", name: "Платен отпуск" },
  { key: "hospital", name: "Болничен" },
  { key: "tripNoOvernight", name: "Командировъчни без преспиване" },
  { key: "tripOvernight", name: "Командировъчни с преспиване" },
];

export default {
  mixins: [log],
  data() {
    return {
      workers: [],
      loaded: false,
      search: "",
      columns: RATE_COLUMNS,
    };
  },
  computed: {
    filtered() {
      const s = this.search.trim().toLowerCase();
      if (!s) return this.workers;
      return this.workers.filter((w) => (w.name || "").toLowerCase().includes(s));
    },
  },
  methods: {
    formatDateTime(d) {
      d = new Date(d);
      const p = (n) => String(n).padStart(2, "0");
      return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
    },
    errorMessage(err) {
      return (err.response && err.response.data && err.response.data.failed) || "Нещо се обърка";
    },
    getRates() {
      this.$store.dispatch("startLoading");
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/salary/rates`)
        .then((response) => {
          this.workers = response.data.map((w) => Object.assign(w, { saving: false }));
        })
        .catch((err) => {
          console.log(err);
          this.$snotify.error(this.errorMessage(err));
        })
        .then(() => {
          this.loaded = true;
          this.$store.dispatch("stopLoading");
        });
    },
    save(w) {
      const rates = {};
      for (const c of this.columns) {
        const v = w.rates[c.key];
        const n = v === "" || v === null ? 0 : Number(v);
        if (!isFinite(n) || n < 0) {
          return this.$snotify.error("Ставките трябва да са числа, по-големи или равни на 0");
        }
        rates[c.key] = n;
      }

      w.saving = true;
      this.$http
        .put(`${process.env.VUE_APP_BASE_URI}/salary/rates/${w._id}`, rates)
        .then((response) => {
          this.columns.forEach((c) => (w.rates[c.key] = response.data[c.key] || 0));
          w.updatedAt = response.data.updatedAt;
          this.$snotify.success(`Ставките на ${w.name} са запазени`);
          this.newLog("editRates", w.name);
        })
        .catch((err) => {
          console.log(err);
          this.$snotify.error(this.errorMessage(err));
        })
        .then(() => (w.saving = false));
    },
  },
  mounted() {
    this.getRates();
  },
};
</script>

<style scoped>
.rates {
  background-color: #f0f7f7;
  min-height: calc(100vh - 100px);
  padding: 10px 40px;
}
.rates-search {
  display: block;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid #c9d9d9;
  border-radius: 4px;
  height: 36px;
  padding: 0 10px;
  width: 250px;
}
.rates-info {
  font-size: 12px;
  margin: 0 0 10px;
}
.rates-empty {
  padding: 40px 0;
  text-align: center;
}
.table-wrapper {
  max-height: calc(100vh - 200px);
  overflow: auto;
}
.rates-table {
  background-color: #fff;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12px;
}
.rates-table th,
.rates-table td {
  border-bottom: 1px solid #c9d9d9;
  border-right: 1px solid #c9d9d9;
  padding: 4px 6px;
  text-align: center;
}
.rates-table thead th {
  background-color: #e8eeee;
  font-weight: 700;
  max-width: 120px;
  position: sticky;
  top: 0;
  z-index: 1;
}
.rates-table .name {
  min-width: 220px;
  text-align: left;
  white-space: nowrap;
}
.rates-table input {
  border: 1px solid #c9d9d9;
  border-radius: 3px;
  height: 28px;
  padding: 0 6px;
  text-align: right;
  width: 90px;
}
.rates-table input:focus {
  border-color: #083f75;
  outline: none;
}
.rates-table .saving input {
  background-color: #fff8e0;
}
.rates-table .updated {
  color: #6b6b6b;
  white-space: nowrap;
}

@media screen and (max-width: 1000px) {
  .rates {
    padding: 10px 15px;
  }
}
</style>
